import { render, staticRenderFns } from "./estoque.vue?vue&type=template&id=2bd6dafa&"
import script from "./estoque.vue?vue&type=script&lang=js&"
export * from "./estoque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports